import { jsx } from "react/jsx-runtime";
import PropTypes from "prop-types";
import "react";
import { useTheme } from "styled-components";
const mediaBreakpointHelper = (breakpoints, breakpoint) => {
  const split = breakpoint.split("_");
  const shirtSize = split[0];
  const strategy = split[1] || "gte";
  if (!breakpoints) {
    return "all";
  }
  const keys = Object.keys(breakpoints);
  const value = breakpoints[shirtSize];
  const index = keys.indexOf(shirtSize);
  if (index < 0) {
    throw new Error(`The breakpoint size '${shirtSize}' does not exist on the theme. Use one of ${keys.map((k) => `'${k}'`).join(", ")}.`);
  }
  if (["lte", "eq", "gte"].indexOf(strategy) < 0) {
    throw new Error(`The strategy '${strategy}' is not valid for breakpoint '${breakpoint}'. Use one of '${shirtSize}_lte', '${shirtSize}_eq', '${shirtSize}_gte'.`);
  }
  let min = "";
  if (strategy !== "lte") {
    min = `(min-width: ${value}px)`;
  }
  let max = "";
  if (strategy !== "gte" && index < keys.length - 1) {
    max = `(max-width: ${breakpoints[keys[index + 1]] - 1}px)`;
  }
  if (min || max) {
    return `${min}${min && max ? " and " : ""}${max}`;
  }
  return "all";
};
const Source = (props) => {
  const theme = useTheme();
  const {
    media
  } = props;
  return /* @__PURE__ */ jsx("source", { ...props, media: media ? mediaBreakpointHelper(theme.constellation.breakpoints, media) : null });
};
Source.propTypes = {
  src: PropTypes.string,
  srcSet: PropTypes.string,
  loading: PropTypes.string,
  media: PropTypes.string
};
Source.defaultProps = {};
export {
  Source as default,
  mediaBreakpointHelper
};
